import { Router } from '@angular/router';
import { ConnectorAuthService } from './connector-auth.service';
import * as i0 from "@angular/core";
import * as i1 from "./connector-auth.service";
import * as i2 from "@angular/router";
var ConnectorAuthGuard = /** @class */ (function () {
    function ConnectorAuthGuard(authService, router) {
        this.authService = authService;
        this.router = router;
    }
    ConnectorAuthGuard.prototype.canActivate = function () {
        if (this.authService.isLoggedIn) {
            return this.authService.isLoggedIn;
        }
        else {
            this.handleNotLoggedIn();
            return this.authService.isLoggedIn;
        }
    };
    ConnectorAuthGuard.prototype.handleNotLoggedIn = function () {
        this.router.navigate(['/connector']);
    };
    ConnectorAuthGuard.ngInjectableDef = i0.defineInjectable({ factory: function ConnectorAuthGuard_Factory() { return new ConnectorAuthGuard(i0.inject(i1.ConnectorAuthService), i0.inject(i2.Router)); }, token: ConnectorAuthGuard, providedIn: "root" });
    return ConnectorAuthGuard;
}());
export { ConnectorAuthGuard };
